import { render, staticRenderFns } from "./HelpCategory.vue?vue&type=template&id=97d929d8&scoped=true&"
import script from "./HelpCategory.vue?vue&type=script&lang=js&"
export * from "./HelpCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d929d8",
  null
  
)

export default component.exports